/**
 * Gets the current time in seconds (Unix timestamp)
 */
export const getCurrentTimeInSeconds = () => {
  return Math.floor(Date.now() / 1000);
};
